import React, {useState, useRef, useEffect} from 'react';
import UserPublicTeamListItem from "./UserPublicTeamListItem.mjs";
import UserListItemMessage from "./UserListItemMessage.mjs";
import { useCTAL } from './CTAL_Hooks.js';

export default function UserPublicTeamList({user_id}) 
{
    const { user_public_team_list } = useCTAL();

    return ( <> { user_public_team_list?.map( (public_team, i) => ( <UserPublicTeamListItem team={public_team} key={i} /> )) } </> );
}